export default function FieldError({ field }: { field: any }) {
    if (field.compute_error) {
        return (
            <div className="flex items-center gap-1 mt-0.5 px-1.5 py-1 bg-red-50 border border-red-200 rounded text-xs text-red-700">
                <span className="material-symbols-outlined text-[14px]">error</span>
                {field.compute_error}
            </div>
        );
    }
    return null;
}
